export default () => ({
  contentHtml: '',
  opened: false,
  loading: false,
  error: null,
  open(data) {
    var images = data.hasOwnProperty('images') ? data.images : []
    var index = data.hasOwnProperty('index') ? data.index : 0
    this.opened = true
    this.loading = true
    document.body.classList.remove('overflow-y-scroll')
    document.body.classList.add('overflow-hidden')
    this.getCarousel(images, index).then((data) => {
      this.contentHtml = data
      this.loading = false
    })
  },
  close() {
    document.body.classList.remove('overflow-hidden')
    document.body.classList.add('overflow-y-scroll')
    this.opened = false
    this.contentHtml = ''
    this.loading = false
    this.error = null
  },
  getCarousel(images = [], index = 0) {
    if (!images) return
    var params = new URLSearchParams({ images: images, index: index })
    return fetch('/lightbox.json?' + params.toString())
      .then((response) => {
        return response.text()
      })
      .catch((error) => {
        console.log(error)
      })
  }
})
